import { render, staticRenderFns } from "./companySeal.vue?vue&type=template&id=14c29efd&scoped=true"
import script from "./companySeal.vue?vue&type=script&lang=js"
export * from "./companySeal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c29efd",
  null
  
)

export default component.exports